// extracted by mini-css-extract-plugin
export var attachmentContainer = "_s4-0";
export var fileList = "_s4-2";
export var removeFileButton = "_s4-1";